import { useEffect, useState } from "react";

const R = 15;
const C = 2 * Math.PI * R;

export const CountdownRing = ({ start, duration }) => {
  const [nowTs, setNowTs] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNowTs(Date.now()), 100);
    return () => clearInterval(id);
  }, [start]);
  const left = Math.max(0, duration - (nowTs - start));
  const frac = left / duration;
  return (
    <div className="flex items-center gap-1.5" data-testid="countdown-ring">
      <svg viewBox="0 0 36 36" className="w-9 h-9 -rotate-90">
        <circle cx="18" cy="18" r={R} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="3" />
        <circle cx="18" cy="18" r={R} fill="none" stroke="#3B9BFF" strokeWidth="3" strokeLinecap="round"
          strokeDasharray={`${C * frac} ${C}`} style={{ transition: "stroke-dasharray 100ms linear" }} />
      </svg>
      <span className="font-rounded text-xs text-neutral-300 tabular-nums w-8" data-testid="countdown-seconds">{Math.ceil(left / 1000)}s</span>
    </div>
  );
};
